
import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';

class ApiSender {

  async sendPin(endpoint, msisdn, language, antiFraudUniqId, clickId) {
    try {
      const baseUrl = process.env.REACT_APP_GTW_URL;
      const response = await fetch(baseUrl + endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          msisdn: msisdn,
          language: language,
          antiFraudUniqId: antiFraudUniqId,
          clickId
        })
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status && result.code === 2000) {
          return { success: true, message: result.message, clickId: result.clickId };
        }
        return { success: false, message: result.message };
      }
      else {
        return { success: false, message: language === 'EN' ? "Failed to send PIN" : "فشل إرسال رقم التعريف الشخصي" };
      }
    }
    catch (error) {
      return { success: false, message: language === 'EN' ? "Failed to send PIN" : "فشل إرسال رقم التعريف الشخصي" };
    }
  }

  async verifyPin(endpoint, msisdn, otp, campaignId, language, trackerId, goalId, goalName, landingPageUrl, landingPageName,
    antiFraudUniqId, params, header, ti, ts) {
    try {
      const date = new Date();
      const formattedDateTime = format(date, "yyyy-MM-dd HH:mm:ssxxx");
      const baseUrl = process.env.REACT_APP_GTW_URL;
      const response = await fetch(baseUrl + endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          msisdn: msisdn,
          pin: otp,
          language: language,
          marketingUuid: campaignId,
          trackerId: trackerId,
          antiFraudUniqId: antiFraudUniqId,
          header: header,
          gclid: params.gclid,
          mfId: params.mf_id,
          gbraid: params.gbraid,
          wbraid: params.wbraid,
          conversionDateTime: formattedDateTime,
          conversionGoalId: goalId,
          conversionGoalName: goalName,
          landingPageUrl: landingPageUrl,
          landingPageName: landingPageName,
          p1: params.p1,
          p2: params.p2,
          p3: params.p3,
          p4: params.p4,
          p5: params.p5,
          p6: params.p6,
          p7: params.p7,
          p8: params.p8,
          p9: params.p9,
          p10: params.p10,
          ti: ti,
          ts: ts
        })
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status && result.code === 2000) {
          return { success: true, message: result.message };
        }
        return { success: false, message: result.message, code: result.code };
      }
      else {
        return { success: false, message: language === 'EN' ? "PIN verification failed" : "فشل التحقق من رقم التعريف الشخصي" };
      }
    }
    catch (error) {
      return { success: false, message: language === 'EN' ? "PIN verification failed" : "فشل التحقق من رقم التعريف الشخصي" };
    }
  }

  async saveHistory(landingPageUrl, params) {
    try {
      let baseUrl = null;
      let endpoint = null;
      let extraParams = null;
      const isGoogleCampaign = params?.hasOwnProperty("gclid");
      if (isGoogleCampaign) {
        baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;
        endpoint = "google/visit";
        const list = ["gclid", "gbraid", "wbraid", "campaignId", "conversions", "cost_micros", "cpa", "utm_source", "utm_medium", "utm_campaign",
          "utm_term", "utm_content", "ad_group_id", "ad_group_name", "ad_id", "keyword_id", "keyword_text", "match_type", "clicks", "impressions",
          "ctr", "average_cpc", "conversion_date", "click_date", "geo_location", "device"];
        extraParams = Object.keys(params).reduce((acc, key) => {
          if (!list.includes(key)) {
            acc[key] = params[key];
          }
          return acc;
        }, {});
      }

      if (endpoint === null) {
        return;
      }

      await fetch(baseUrl + endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          gclid: params.gclid,
          gbraid: params.gbraid,
          wbraid: params.wbraid,
          campaign: params.campaignId,
          conversions: params.conversions,
          costMicros: params.cost_micros,
          cpa: params.cpa,
          utmSource: params.utm_source,
          utmMedium: params.utm_medium,
          utmCampaign: params.utm_campaign,
          utmTerm: params.utm_term,
          utmContent: params.utm_content,
          adGroupId: params.ad_group_id,
          adGroupName: params.ad_group_name,
          adId: params.ad_id,
          keywordId: params.keyword_id,
          keywordText: params.keyword_text,
          matchType: params.match_type,
          clicks: params.clicks,
          impressions: params.impressions,
          ctr: params.ctr,
          averageCpc: params.average_cpc,
          conversionDate: params.conversion_date,
          clickDate: params.click_date,
          geoLocation: params.geo_location,
          device: params.device,
          landingPageUrl: landingPageUrl,
          extraParams: JSON.stringify(extraParams)
        })
      });
    }
    catch (error) {
    }
  }
  
  async loadExternalScript(msisdn, alreadyInjected) {
    return new Promise(async (resolve, reject) => {
      try {
        const time = new Date().getTime();
        const clientId = uuidv4() + '-' + time;
        let status = false;
        let antiFraudUniqId = null;
        let ti = null;
        let ts = null;
        let scriptInjected = false;
        let clickId = null;
        const stateParams = new URLSearchParams(window.location.state);
        if (window.location.pathname === '/success' || window.location.pathname === '/terms') {
          resolve({ clientId, status, antiFraudUniqId, ti, ts, scriptInjected, clickId });
          return;
        }
        const css_selector = '#verify-btn';
        const te = encodeURIComponent(css_selector);
        const service = 'kidsecurity';
        const country = 'KW';
        const carrier = '41903';
        let requestParams = `te=${te}&country=${country}&service=${service}&carrier=${carrier}`;
        if(msisdn !== null && msisdn !== undefined)
        {
          requestParams = `${requestParams}&user_id=${msisdn}`;
        }
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const checkHeader = await fetch(process.env.REACT_APP_GTW_URL + "header-check", {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept-Encoding': 'application/gzip' },
          body: JSON.stringify({
            clientId: clientId,
            url: window.location.href,
            alreadyAdded: urlParams.has('ClientID') || window.location.pathname === '/verify',
            msisdn: msisdn,
            requestParams: requestParams,
            alreadyInjected: alreadyInjected
          })
        });
        if (checkHeader.ok) {
          const data = await checkHeader.json();
          status = data.status;
          const operatorId = data.operator;
          if (operatorId === 1 || operatorId === 3) {
            const isStcPage = window.location.hostname === 'stckw.kid-security.io' || window.location.pathname.startsWith('/stc');
            const fraud_api = `${isStcPage ? 'https' : 'http'}://antifraud.cgparcel.net/AntiFraud/Prepare/`;
            const page = window.location.pathname === '/verify' ? '2' : '1';
            const channelId = data.channelId;
            clickId = data.clickId;
            const header = data.headers;
            const userIp = data.userIp;
            const url = `${fraud_api}?Page=${page}&ChannelID=${channelId}&ClickID=${clickId}&Headers=${header}&UserIP=${userIp}`;
            console.log(url);
            const response = await fetch(url, { method: 'GET' });
            if (response.ok) {
              if (window.location.pathname === '/verify') {
                antiFraudUniqId = stateParams.has('antiFraudUniqId') ? stateParams.antiFrauduniqid : null;
              }
              if (antiFraudUniqId === null) {
                const headers = response.headers;
                antiFraudUniqId = headers.has("AntiFrauduniqid") ? headers.get("AntiFrauduniqid") : null;
              }
              const scriptText = await response.text();
              const script = document.createElement('script');
              script.type = 'text/javascript';
              script.innerHTML = scriptText;
              document.head.appendChild(script);
            }
          }
          if (operatorId === 2) {
            if (data && data.script && data.script !== null) {
              ts = data.ts;
              ti = data.ti;
              const scriptTag = document.createElement('script');
              scriptTag.type = "text/javascript";
              scriptTag.text = data.script;
              scriptTag.async = true;
              document.head.appendChild(scriptTag);
              var event = new Event("DCBProtectRun");
              document.dispatchEvent(event);
              scriptInjected = true;
              console.log("Script Injected !");
            }
          }
          resolve({ clientId, status, antiFraudUniqId, ti, ts, scriptInjected, clickId });
          return;
        }
        console.error("header-check request failed", checkHeader.status, checkHeader.statusText);
        resolve({ clientId, status, antiFraudUniqId, ti, ts, scriptInjected, clickId });
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  }
}

export default ApiSender;